export const CHANNEL_CONNECTION_CHANGED_EVENT = 'rk:channel-connection-changed'

export type ChannelConnectionName = 'whatsapp' | 'instagram' | 'messenger' | 'facebook_ads' | 'other'

export interface ChannelConnectionChangedDetail {
  channel: ChannelConnectionName
  connected: boolean
  at: string
}

export function notifyChannelConnectionChanged(
  detail: Omit<ChannelConnectionChangedDetail, 'at'> & { at?: string }
): void {
  if (typeof window === 'undefined') {
    return
  }

  const eventDetail: ChannelConnectionChangedDetail = {
    channel: detail.channel,
    connected: detail.connected,
    at: detail.at ?? new Date().toISOString(),
  }

  window.dispatchEvent(
    new CustomEvent<ChannelConnectionChangedDetail>(CHANNEL_CONNECTION_CHANGED_EVENT, {
      detail: eventDetail,
    })
  )
}

export function subscribeToChannelConnectionChanged(
  callback: (detail: ChannelConnectionChangedDetail) => void
): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<ChannelConnectionChangedDetail>
    if (customEvent.detail) {
      callback(customEvent.detail)
    }
  }

  window.addEventListener(CHANNEL_CONNECTION_CHANGED_EVENT, handler as EventListener)
  return () => {
    window.removeEventListener(CHANNEL_CONNECTION_CHANGED_EVENT, handler as EventListener)
  }
}
